import React from 'react';

export default function FullscreenLoading({ open, text = 'Enviando...' }) {
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        backgroundColor: 'rgba(17, 24, 39, 0.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 20000,
        padding: 16,
      }}
    >
      <div
        style={{
          background: '#fff',
          borderRadius: 12,
          border: '1px solid #E5E7EB',
          padding: 16,
          minWidth: 260,
          fontWeight: 800,
          color: '#111827',
          textAlign: 'center',
          boxShadow: '0 24px 60px rgba(0,0,0,0.18)',
        }}
      >
        {text}
      </div>
    </div>
  );
}
